// TODO : split qquick payments in different components
import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { remarksSelector } from '../../../selectors/account.selector'
import DashboardService from '../../../services/dashboard.service'
import { setRemarks } from '../../../actions'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { Col, Row } from 'react-bootstrap'
import InstantTransferIcon from 'custom/assets/quickTransfer/InstantTransfer.svg'
import SendToMobileIcon from 'custom/assets/quickTransfer/SentToMobile.svg'
import { useHistory, useLocation } from 'react-router-dom'
import { getMenuListSelector } from '../../../selectors'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'
import DynamicMenuCard from '../../../layout/Navigation/DynamicCard'
import PaymentsService from '../../../services/payments.service'
import BankToWalletIcon from "custom/assets/quickTransfer/BankWallet.svg"

const ICONS = {
  BANKTOWALLET: BankToWalletIcon
}
export default function QuickPay() {
  const history = useHistory()
  const location = useLocation()
  const remarks = useSelector(remarksSelector)
  const dispatch = useDispatch()
  const menuConfig = useSelector(getMenuListSelector)['QUICK_TRANSFER'] || {}
  const [billerList, setBillerList] = useState([])
  const [data, setData] = useState({})

  
const menuDetails = MENU_OPTIONS.filter((ele) => ele.key ===  (location.pathname.includes('/beneficiary-transfers')?'TRANSFER':'ACCOUNTS'))[0]?.children
const subMenuDetails = menuDetails.filter((ele) => ele.key === 'QUICK_TRANSFER')[0]?.children


  useEffect(() => {
    location.pathname.includes('/beneficiary-transfers') && setData({url:'/beneficiary-transfers', breadCrumb:'TRANSFERS_QUICK_PAY'})
    location.pathname.includes('/accounts') && setData({url:'/accounts', breadCrumb:'ACCOUNTS_QUICK_PAY'})
    getRemarksList()
    getBillProducts()
  }, [])

  const getBillProducts = useCallback(async () => {
    try {
      const response = await PaymentsService.getAllBillers({
        fetchServices: false,
        fetchProducts: false,
        module: 'TRANSFER',
      })
      if (response.status === 200) {
        response.data['categories'].forEach((element) => {
          element.title = element.category
          element.icon = ICONS[element.category]
          element.key = element.category
        })
        setBillerList(response.data['categories'])
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  const getRemarksList = useCallback(async () => {
    try {
      if (remarks.length == 0) {
        const response = await DashboardService.getRemarksCategory()
        if (response.status === 200) {
          dispatch(setRemarks(response.data.remarks))
        }
      }
    } catch (err) {}
  }, [dispatch])

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <div className=''>
        <Row>
          {Object.keys(menuConfig).length > 0 &&
            subMenuDetails.map((option, index) => (
              <>
                {menuConfig[option.key] && (
                  <MenuCard
                    handleMenuCallback={() => history.push(option.link)}
                    icon={option.icon}
                    name={option.title}
                    description={option.desc}
                    key={index}
                  />
                )}
              </>
            ))}
          {billerList.map((option, index) => (
            <DynamicMenuCard
              handleMenuCallback={() =>
                history.push({
                  pathname: `${data.url}/quick-pay/serviceView`,
                  state: { categoryDetails: option },
                })
              }
              icon={option.icon}
              name={option.title}
              description={option.description}
              key={index}
            />
          ))}
        </Row>
      </div>
    </LayoutWithAccountCard>
  )
}
